import { render } from "./downloadLoanSubmission.vue?vue&type=template&id=554a2270&scoped=true"
import script from "./downloadLoanSubmission.vue?vue&type=script&lang=js"
export * from "./downloadLoanSubmission.vue?vue&type=script&lang=js"

import "./downloadLoanSubmission.vue?vue&type=style&index=0&id=554a2270&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-554a2270"]])

export default __exports__